import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3.5 10.0509V3.72684C3.5 2.86399 4.51946 2.40619 5.16436 2.97943L8 5.5L10.8356 2.97943C11.4805 2.40619 12.5 2.864 12.5 3.72684V10.0509C12.5 10.3366 12.3779 10.6086 12.1644 10.7983L8.66436 13.9095C8.28548 14.2462 7.71452 14.2462 7.33564 13.9095L3.83564 10.7983C3.62215 10.6086 3.5 10.3366 3.5 10.0509Z"
            stroke="currentColor"
            strokeLinecap="round"
        />
        <path d="M8 5.5V14" stroke="currentColor" strokeLinecap="round" />
    </svg>
);

export default Icon;
